// extracted by mini-css-extract-plugin
module.exports = {"alert":"_eEUMIzMg","blueAlert":"_rTuTVlZa"};